<emm-nutrition-assignments-location-sets-list
    class="nutrition-assignments-location-sets"
    [nodes]="nodes$ | async"
    [shift]="0"
></emm-nutrition-assignments-location-sets-list>
